// extracted by mini-css-extract-plugin
export default {"FlashMessage":"FlashMessage_FlashMessage__cvlRj"};